import { useEffect, useState } from 'react';
import { onSpoken } from '../lib/voice.js';
import styles from './CalloutCaption.module.css';

/** A caption stays up at least this long, and this much past its last word. */
const MIN_SHOWN_MS = 2_200;
const LINGER_MS = 1_200;

/**
 * The dealer's call, written on the felt: "Seven out. Line away." It shows
 * each call as the voice gets to it — spoken or, with sound off or a clip not
 * loaded yet, silent — and clears once the words are done.
 */
export function CalloutCaption() {
  const [shown, setShown] = useState<{ key: string; text: string } | null>(null);

  useEffect(() => {
    let timer: number | undefined;
    const off = onSpoken(({ call, durationMs }) => {
      window.clearTimeout(timer);
      setShown({ key: call.key, text: call.text });
      timer = window.setTimeout(() => setShown(null), Math.max(MIN_SHOWN_MS, durationMs + LINGER_MS));
    });
    return () => {
      off();
      window.clearTimeout(timer);
    };
  }, []);

  if (!shown) return null;
  return (
    <p key={shown.key} className={styles.caption} role="status" aria-live="polite">
      {shown.text}
    </p>
  );
}
